/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConditionType = "contains" | "endsWith" | "equals" | "greaterThan" | "greaterThanOrEqual" | "inRange" | "lessThan" | "lessThanOrEqual" | "notContains" | "notEqual" | "startsWith" | "%future added value";
export type FilterType = "date" | "number" | "text" | "%future added value";
export type OperatorType = "AND" | "OR" | "%future added value";
export type Filter = {|
  name: string,
  filterType: FilterType,
  operator: OperatorType,
  denySelection?: ?boolean,
  conditions: $ReadOnlyArray<?Condition>,
|};
export type Condition = {|
  value: $ReadOnlyArray<?string>,
  type: ConditionType,
|};
export type Filter1NotEquippedUsageUnitsCountQueryVariables = {|
  companyId: string,
  filters?: ?$ReadOnlyArray<?Filter>,
|};
export type Filter1NotEquippedUsageUnitsCountQueryResponse = {|
  +Me: ?{|
    +id: string,
    +Company: ?{|
      +data: ?number
    |},
  |}
|};
export type Filter1NotEquippedUsageUnitsCountQuery = {|
  variables: Filter1NotEquippedUsageUnitsCountQueryVariables,
  response: Filter1NotEquippedUsageUnitsCountQueryResponse,
|};
*/


/*
query Filter1NotEquippedUsageUnitsCountQuery(
  $companyId: ID!
  $filters: [Filter]
) {
  Me {
    id
    Company(id: $companyId) {
      data: countUsageUnits(options: {filters: $filters}, context: RecentRegularAppointment)
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v3 = {
  "alias": "data",
  "args": [
    {
      "kind": "Literal",
      "name": "context",
      "value": "RecentRegularAppointment"
    },
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countUsageUnits",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Filter1NotEquippedUsageUnitsCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Filter1NotEquippedUsageUnitsCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a039a3450ae6076d76cac4f8d3a60c72",
    "id": null,
    "metadata": {},
    "name": "Filter1NotEquippedUsageUnitsCountQuery",
    "operationKind": "query",
    "text": "query Filter1NotEquippedUsageUnitsCountQuery(\n  $companyId: ID!\n  $filters: [Filter]\n) {\n  Me {\n    id\n    Company(id: $companyId) {\n      data: countUsageUnits(options: {filters: $filters}, context: RecentRegularAppointment)\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '638dae44e87f22e97c818621f7baca7c';

module.exports = node;
